const CustomElementListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Element Name',
    dataIndex: 'element_name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    slot: 'element_name',
    width: 250
  },
  {
    title: 'Description',
    dataIndex: 'description',
    slot: 'description',
    width: 250
  },
  {
    title: 'XPath',
    dataIndex: 'xpath',
    slot: 'xpath',
    width: 250
  },  
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];
export { CustomElementListColumn };
